import { apiService } from './api.service';
import { CR_API_ENDPOINTS } from '../constants';
import { LenderDetail, CreateLenderPayload, UpdateLenderPayload } from '../types/clients.types';

class LendersService {
  /**
   * Fetches all active lenders.
   * @returns Array of active lenders
   */
  async getAll(): Promise<LenderDetail[]> {
    return apiService.get<LenderDetail[]>(CR_API_ENDPOINTS.LENDERS);
  }

  /**
   * Creates a new lender associated with a client.
   * @param data - Lender creation payload including clientId
   * @returns The created lender
   */
  async create(data: CreateLenderPayload): Promise<LenderDetail> {
    return apiService.post<LenderDetail>(CR_API_ENDPOINTS.LENDERS, data);
  }

  /**
   * Updates an existing lender's name.
   * @param id - Lender UUID
   * @param data - Lender update payload
   * @returns The updated lender
   */
  async update(id: string, data: UpdateLenderPayload): Promise<LenderDetail> {
    return apiService.put<LenderDetail>(`${CR_API_ENDPOINTS.LENDERS}/${id}`, data);
  }

  /**
   * Updates a lender's status (active/inactive).
   * @param id - Lender UUID
   * @param status - New status value
   * @returns The updated lender
   */
  async updateStatus(id: string, status: string): Promise<LenderDetail> {
    return apiService.put<LenderDetail>(`${CR_API_ENDPOINTS.LENDERS}/${id}/status`, { status });
  }

  /**
   * Deactivates a lender (soft delete).
   * @param id - Lender UUID
   */
  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`${CR_API_ENDPOINTS.LENDERS}/${id}`);
  }
}

export const lendersService = new LendersService();
